import styled from 'styled-components';

export const ConfirmationContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-top: 24px;
	@media (min-width: 671px) {
		padding-top: 18px;
	}
`;

export const HeaderWrapper = styled.div`
	@media print {
		display: none !important;
	}
`;

export const CalendarIcon = styled.img`
	width: 44px;
	height: 44px;
	object-fit: contain;
	margin-bottom: 15px;
`;

export const Title = styled.h1`
	margin: 0 0 26px;
	color: #4a5565;
	font-family: "Inter", sans-serif;
	font-weight: 700;
	font-style: normal;
	font-size: 32px;
	line-height: 100%;
	letter-spacing: 0;
	text-align: center;
	@media (min-width: 671px) {
		margin-bottom: 40px;
		line-height: 39px;
	}
`;

export const Details = styled.div`
	width: min(535px, 100%);
`;

export const Detail = styled.div`
	min-height: 50px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	border-bottom: 1px dotted #aeb7c3;
	color: #596578;
	font: 400 10px/120% "Inter", sans-serif;

	strong {
		color: #26364c;
		font-family: "Inter", sans-serif;
		font-weight: 600;
		font-style: normal;
		font-size: 14px;
		line-height: 100%;
		letter-spacing: 0;
		white-space: nowrap;
	}

	span {
		max-width: 245px;
		font-family: "Inter", sans-serif;
		font-weight: 400;
		font-style: normal;
		font-size: 14px;
		line-height: 100%;
		letter-spacing: 0;
		text-align: right;
	word-break: break-word;
	}
	@media (min-width: 671px) {
		min-height: 33px;
		margin-bottom: 16px;
		&:last-child { margin-bottom: 0; }
	}
`;

export const PrintButton = styled.button`
	min-width: 135px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 7px;
	margin-top: 40px;
	border: 0;
	background: #008bd2;
	color: #f9fafb;
	font-family: "Inter", sans-serif;
	font-weight: 600;
	font-style: normal;
	font-size: 14px;
	line-height: 100%;
	letter-spacing: 0;
	cursor: pointer;
	@media print {
		display: none !important;
	}
`;

export const PrintIcon = styled.img`
	width: 20px;
	height: 20px;
	object-fit: contain;
`;

export const EmptyState = styled.div`
	display: flex;
	min-height: 802px;
	background: #e4e7eb;
	align-items: center;
	justify-content: center;
	color: #4a5565;
	font-family: "Inter", sans-serif;
	font-weight: 700;
	font-style: normal;
	font-size: 32px;
	line-height: 100%;
	letter-spacing: 0;
	text-align: center;
`;
